module.exports = __webpack_public_path__ + "img/110.4.a54d3064.png";